import { MenuGroup } from './types';
import { loadFeatureData } from './utils/feature-loader';

// This will be replaced by dynamic loading in the App component
export let menuData: MenuGroup[] = [];

// Function to initialize menu data
export const initializeMenuData = async (): Promise<MenuGroup[]> => {
  try {
    const data = await loadFeatureData();
    menuData = data;
    return data;
  } catch (error) {
    console.error('Failed to load feature data:', error);
    // Return fallback empty data
    return [];
  }
};

/*
export const menuData-old: MenuGroup[] = [
  {
    id: 'home',
    label: 'Home',
    icon: <HomeIcon className="h-5 w-5" />,
    features: [
        { id: 'managetenants', label: 'Manage Tenants', icon: <ShieldCheckIcon className="h-4 w-4" /> },
        { id: 'n20-bucket-01-LibBucket', label: 'LibBucket', icon: <Cog6ToothIcon className="h-4 w-4" /> },
      { id: 'dashboard', label: 'Dashboard', icon: <ChartBarIcon className="h-4 w-4" /> },
    ]
  },
  {
    id: 'advanced',
    label: 'Advanced',
    icon: <SparklesIcon className="h-5 w-5" />,
    features: [
      { id: 'optimizer', label: 'Optimizer', icon: <WrenchScrewdriverIcon className="h-4 w-4" /> },
      { id: 'compliance', label: 'Compliance', icon: <ShieldCheckIcon className="h-4 w-4" /> }
    ]
  }
];
*/
